import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
export type AccommodationCardCapacityProperties = {
  capacity: number;
  extraCapacity: number;
};
export const AccommodationCardCapacity: React.FC<AccommodationCardCapacityProperties> = t0 => {
  const $ = _c(7);
  const {
    capacity,
    extraCapacity
  } = t0;
  if (capacity === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className=""><MaterialIcon name="person" variant="outlined" className="text-on-surface-medium-emphasis !text-[16px]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== capacity) {
    t2 = numberConvert(capacity, {
      numberOnly: false,
      locale: "fa"
    });
    $[1] = capacity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== extraCapacity) {
    t3 = extraCapacity > 0 ? `+ ${numberConvert(extraCapacity, {
      numberOnly: false,
      locale: "fa"
    })} نفر اضافه` : "";
    $[3] = extraCapacity;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${t2} نفر پایه ${t3}`;
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="text-extra-caption text-on-surface-medium-emphasis mt-1 flex justify-start gap-1 truncate font-[400]">{t1}{t4}</div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};